import { client } from '@/common-utils/libraries/axios/axios';
import PAYLUDD_BENEFICIARIES from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationCreateBeneficiary = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractAccessId, color, name }) => {
            return client.post(
                replaceParameters(PAYLUDD_BENEFICIARIES.CREATE_PAYLUDD_BENEFICIARY.url, {
                    contractAccessId
                }),
                { color, name }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateBeneficiary;

